import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-regular-svg-icons'

type ExpectedIconProps = { expected: string }

export const ExpectedIcon: React.FC<ExpectedIconProps> = ({ expected }) => (
  <FontAwesomeIcon icon={faClock} size="lg" />
)
